import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InnerFooterComponent } from './inner-footer.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';



@NgModule({
  declarations: [
    InnerFooterComponent
  ],
  imports: [
    CommonModule,
    RouterModule,   
    FormsModule,   
    CollapseModule.forRoot(),
    BsDropdownModule,   
  ],
  providers: [],
  exports     : [
    InnerFooterComponent
  ],
  entryComponents : [InnerFooterComponent]
})
export class InnerFooterModule { }
